import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: `copyStrategyModal-${_ctx.Strategy.id}`,
    tabindex: "-1",
    "aria-labelledby": "copyStrategyModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: "copyStrategyModalLabel"
          }, "Copy Strategy"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.copyStrategy($event)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                for: "StrategyDescription",
                class: "form-label"
              }, "Strategy Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "StrategyDescription",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
                required: "",
                placeholder: "Enter Strategy name"
              }, null, 512), [
                [_vModelText, _ctx.description]
              ]),
              (_ctx.isNameNotValid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Strategy with such name already exists. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "facilitySelect",
                class: "form-label"
              }, "Copy to Facility", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "facilitySelect",
                class: "form-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.facilityId) = $event)),
                required: ""
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Select a Facility", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Facilities, (facility) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: facility.id,
                    value: facility.id
                  }, _toDisplayString(facility.name), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.facilityId]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-2",
                "data-bs-dismiss": "modal"
              }, " Cancel ", -1)),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.isNameNotValid
              }, " Create ", 8, _hoisted_10)
            ])
          ], 32)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}